import Cookies from "js-cookie";
import AuthorizationInfo from "../models/user/AuthorizationInfo";

const tokenKey = "token";
const aaiTokenCookieName = "ETUR-AUTH";

export const setAuthorizationToken = (authorizationToken: string) => {
  localStorage.setItem(tokenKey, authorizationToken);
};

export const getAuthorizationToken = () => {
  return localStorage.getItem(tokenKey);
};

export const removeAuthorizationToken = () => {
  localStorage.removeItem(tokenKey);
};

export const getAaiToken = () => {
  const aaiToken = Cookies.get(aaiTokenCookieName);

  return aaiToken;
};

export const removeAaiToken = () => {
  Cookies.remove(aaiTokenCookieName);
};

export const getAuthorizationInfo = (): AuthorizationInfo | undefined => {
  const authorizationToken = localStorage.getItem(tokenKey);
  if (authorizationToken) {
    const authorizationInfo = parseAuthorizationToken(authorizationToken);

    return authorizationInfo;
  }
};

const parseAuthorizationToken = (authorizationToken: string) => {
  let base64Url = authorizationToken.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  let obj = JSON.parse(jsonPayload);

  let institutionTypes: number[] = [];
  if (obj["institution_types"]) {
    let typeParts = obj["institution_types"].split(",");
    typeParts.forEach((t: string) => {
      institutionTypes.push(parseInt(t));
    });
  }

  let authorizationInfo = {
    roleId: parseInt(obj["role"]),
    username: obj["unique_name"],
    firstName: obj["given_name"],
    lastName: obj["family_name"],
    institutionName: obj["institution_name"],
    institutionCode: obj["institution_code"],
    institutionTypes: institutionTypes
  } as AuthorizationInfo;

  return authorizationInfo;
};
